import React, { lazy, Suspense } from 'react';
import {
    CustomRoutes,
    Loading,
    AdminContext,
    AdminUI
} from "react-admin";
import { Route } from "react-router-dom"
import { useParams, useSearchParams } from 'react-router-dom';
import { dataProvider, authProvider } from '@switch/widget';
import english from "./locales/en/translation.json";
import debug from "./locales/debug/translation.json";
import { useSwitchTheme, SwitchThemeContextProvider, TranslationLoaderContextProvider, useTranslationLoader, LoadingContextProvider } from '@switch/core'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { enGB } from 'date-fns/locale'
import { GetAuth0Client } from '@switch/core';
import { useBookingWidgetAuthentication } from './Authentication/context/useBookingWidgetAuthentication';

const WidgetBase = lazy(() => import("@switch/widget").then(module => ({ default: module.WidgetBase })));
//const dataProvider = lazy(() => import("@switch/widget").then(module => ({ default: module.dataProvider })));
const Layout = lazy(() => import("@switch/widget").then(module => ({ default: module.Layout })));

export const WidgetLoader = () => {
    return (
        <Suspense fallback={<Loading />}>
            <LoadingContextProvider>
                <TranslationLoaderContextProvider defaults={{ english, debug }} storekey='widget.settings.translation' >
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                        <SwitchThemeContextProvider>
                            <ThemeWrapper />
                        </SwitchThemeContextProvider>
                    </LocalizationProvider>
                </TranslationLoaderContextProvider>
            </LoadingContextProvider>
        </Suspense>
    );
}

const ThemeWrapper = () => {
    const { theme } = useSwitchTheme()
    const params = useParams();
    const auth0 = GetAuth0Client();
    const urlParams = Object.values(params)[0]
    const widgetId = urlParams.split("/")?.[0]
    const dateProviderInstance = dataProvider(widgetId, auth0)
    const authProviderInstance = authProvider(widgetId, auth0)
    const [searchParams, setSearchParams] = useSearchParams();
    const sessionKey = searchParams.get("sessionKey")
    const { i18nProvider } = useTranslationLoader()
    const { requestToRestore } = useBookingWidgetAuthentication();

    return (
        <AdminContext
            basename="/widget"
            dataProvider={dateProviderInstance}
            authProvider={authProviderInstance}
            theme={theme?.light}
            darkTheme={theme?.dark}
            i18nProvider={i18nProvider}
        >
            <AdminUI
                layout={Layout}
            >
                <CustomRoutes>
                    <Route path="/:widgetId/*" element={<WidgetBase widgetId={widgetId} sessionKey={sessionKey} requestToRestore={requestToRestore} />} />
                </CustomRoutes>
            </AdminUI>
        </AdminContext>
    )
}